import React, { useContext } from 'react';
import type { UserProfileSettings } from 'venn-api';
import { Loading } from 'venn-ui-kit';
import { useHasFF } from 'venn-utils';
import { AdvisoryFeesSection } from './components/advisory-fees/AdvisoryFeesSection';
import CashflowSettings from './components/cashflow-settings/CashflowSettings';
import FactorForecasts from './components/FactorForecasts';
import AddeparIntegration from './components/integrations/AddeparIntegration';
import Integrations from './components/integrations/Integrations';
import MasterPortfolioSection from './components/MasterPortfolioSection';
import OrganizationCurrency from './components/OrganizationCurrency';
import PrintSettingsSection from './components/PrintSettingsSection';
import { ReportLabFontSizeDefaultsSection } from './components/ReportLabFontSizeDefaultsSection';
import WorkspaceTaxRateDefaultsSection from './components/tax-rate/WorkspaceTaxRateDefaultsSection';
import Templates from './components/templates/Templates';
import { UserContext } from 'venn-components';

export const WorkspaceConfiguration = ({ profileSettings }: { profileSettings: UserProfileSettings }) => {
  const hasAddeparSelfService = useHasFF('addepar_self_service');
  const hasStudioReportEditor = useHasFF('studio_report_editor');
  const hasPrivatesFF = useHasFF('private_analytics');
  const hasDefaultRLAdvisoryFeesFF = useHasFF('default_rl_advisory_fees_ff');
  const hasTaxImpactFF = useHasFF('tax_impact_ff');

  const { hasPermission } = useContext(UserContext);
  const hasEditHyperparametersPermission = hasPermission('EDIT_HYPERPARAMETERS');

  return (
    <>
      <MasterPortfolioSection profileSettings={profileSettings} />
      <OrganizationCurrency profileSettings={profileSettings} />
      {hasTaxImpactFF && <WorkspaceTaxRateDefaultsSection />}
      {hasStudioReportEditor && <ReportLabFontSizeDefaultsSection />}
      {hasStudioReportEditor ? <PrintSettingsSection hasDefaultRLAdvisoryFeesFF={hasDefaultRLAdvisoryFeesFF} /> : null}
      {hasDefaultRLAdvisoryFeesFF && <AdvisoryFeesSection />}
      <React.Suspense fallback={<Loading title="Forecasts are loading... " />}>
        <FactorForecasts />
      </React.Suspense>
      {hasEditHyperparametersPermission && hasPrivatesFF && <CashflowSettings />}
      <Templates />
      {hasAddeparSelfService ? <AddeparIntegration /> : <Integrations />}
    </>
  );
};

export default WorkspaceConfiguration;
